import * as React from 'react';
import { Alert, Snackbar } from "@mui/material";

export const getDeviceType = () => {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "tablet";
  }
  if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
    return "mobile";
  }
  return "desktop";
};
export function formataData(sdt) {
  if (!sdt) return '';
  const dt = new Date(sdt);

  return dt.toLocaleDateString();
}

export function formataDataHora(sdt) {
  if (!sdt) return '';
  const dt = new Date(sdt);

  return dt.toLocaleDateString() + " " + dt.toLocaleTimeString();
}

export function prettify(html) {
  const tab = '\t';
  let result = '';
  let indent = '';

  html.split(/>\s*</).forEach(function (element) {
    const openCount = (element.match(/(^|<)\w(|[^<>]*[^<>/])(>|$)/g) || []).length;
    const closeCount = (element.match(/(^|<)\/\w(|[^<>]*)(>|$)/g) || []).length;
    let delta = openCount - closeCount;
    // if closing, reduce this indent
    if (delta < 0) indent = indent.substring(tab.length * -delta);
    result += indent + '<' + element + '>\r\n';
    // if opening, increase the following indent
    for (; delta > 0; delta--) indent += tab;
  });
  return result.substring(1, result.length - 3);
}

export async function copyStringToClipboard(textToCopy) {
  try {
    await navigator.clipboard.writeText(textToCopy);
  } catch (err) {
    console.error('Failed to copy text: ', err);
  }
}


export function SnackbarsVy(props) {
  const { open, setOpen, severity, msg } = props;

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
      <Alert
        onClose={handleClose}
        severity={severity}
        // severity="error"
        variant="filled"
        sx={{ width: '100%' }}
      >
        {msg}
      </Alert>
    </Snackbar>

  );
}

export function useInterval(delay, callback) {
  const savedCallback = React.useRef();

  // Remember the latest callback.
  React.useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  React.useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}